import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'transferType'
})
export class TransferTypePipe implements PipeTransform {

  transform(value: string): string {
    if(value === 'internal'){
      return 'داخلی'
    }else if(value === 'external'){
      return 'خارجی'
    } else {
      return '';
    }
  }

}
